import React from "react";
import { Switch, Route } from "react-router-dom";
import { Home } from "../views/home/Home";
//电子名片管理
import { Card } from "../views/card/view";
//公司介绍管理
import { AboutUs } from "../views/aboutUs/view";
//业务介绍管理
import { Introductions } from "../views/introductions/view";
//名片夹管理
import { Cardcase } from "../views/cardcase/view";
//数据字典
import { BaseDict } from "../views/base/dict/view";
import Error404 from "../views/404";

function AppRoute() {
    return (
        <Switch>
            <Route exact={true} path={"/"} key="1" component={Home} />
            <Route exact={true} path={"/card"} key="2" component={Card} />
            <Route exact={true} path={"/company"} key="3" component={AboutUs} />
            <Route exact={true} path={"/business"} key="4" component={Introductions} />
            <Route exact={true} path={"/cardcase"} key="5" component={Cardcase} />
            <Route exact={true} path={"/base/dict"} key="6" component={BaseDict} />
            <Route exact={true} path={"/*"} key="404" component={Error404} />
        </Switch>
    )
}

export default AppRoute;